const foods = [
  // === Rice Dishes ===
  {
    id: 1,
    name: "Jollof Rice & Chicken",
    description: "Smoky party-style jollof served with juicy grilled chicken.",
    price: 2500,
    image: "/foods/rice-1.jpg",
    category: "rice",
  },
  {
    id: 2,
    name: "Fried Rice & Turkey",
    description: "Colorful fried rice with seasoned grilled turkey.",
    price: 2800,
    image: "/foods/rice-2.jpg",
    category: "rice",
  },
  {
    id: 3,
    name: "White Rice & Stew",
    description: "Steamed white rice served with spicy tomato stew.",
    price: 1200,
    image: "/foods/rice-3.jpg",
    category: "rice",
  },

  // === Swallow Dishes ===
  {
    id: 4,
    name: "Egusi Soup & Pounded Yam",
    description: "Rich melon seed soup served with soft pounded yam.",
    price: 3000,
    image: "/foods/swallow-1.jpg",
    category: "swallow",
  },
  {
    id: 5,
    name: "Eba & Okra Soup",
    description: "Garri (eba) paired with slippery okra soup.",
    price: 2200,
    image: "/foods/swallow-2.jpg",
    category: "swallow",
  },
  {
    id: 6,
    name: "Amala & Ewedu Soup",
    description: "Yam flour meal served with ewedu and gbegiri soup.",
    price: 2500,
    image: "/foods/swallow-3.jpg",
    category: "swallow",
  },

  // === Soups ===
  {
    id: 7,
    name: "Pepper Soup (Goat Meat)",
    description: "Spicy broth with tender goat meat chunks.",
    price: 2000,
    image: "/foods/soup-1.jpg",
    category: "soups",
  },
  {
    id: 8,
    name: "Catfish Pepper Soup",
    description: "Fresh catfish cooked in hot, spicy broth.",
    price: 2200,
    image: "/foods/soup-2.jpg",
    category: "soups",
  },
  {
    id: 9,
    name: "Oha Soup",
    description: "Traditional Igbo soup rich with oha leaves.",
    price: 2800,
    image: "/foods/soup-3.jpg",
    category: "soups",
  },

  // === Grills ===
  {
    id: 10,
    name: "Suya",
    description: "Spicy beef skewers grilled to perfection, Northern style.",
    price: 1500,
    image: "/foods/grills-1.jpg",
    category: "grills",
  },
  {
    id: 11,
    name: "Grilled Chicken Wings",
    description: "Juicy chicken wings marinated with hot spices.",
    price: 1800,
    image: "/foods/grills-2.jpg",
    category: "grills",
  },
  {
    id: 12,
    name: "Barbecue Fish",
    description: "Grilled whole fish brushed with spicy sauce.",
    price: 3500,
    image: "/foods/grills-3.jpg",
    category: "grills",
  },

  // === Beans ===
  {
    id: 13,
    name: "Beans Porridge",
    description: "Slow-cooked beans with palm oil and spices.",
    price: 1800,
    image: "/foods/beans-1.jpg",
    category: "beans",
  },
  {
    id: 14,
    name: "Akara (Bean Cakes)",
    description: "Crispy fried bean cakes, perfect for breakfast.",
    price: 800,
    image: "/foods/beans-2.jpg",
    category: "beans",
  },
  {
    id: 15,
    name: "Moin-Moin",
    description: "Steamed bean pudding wrapped in leaves.",
    price: 1000,
    image: "/foods/beans-3.jpg",
    category: "beans",
  },

  // === Drinks ===
  {
    id: 16,
    name: "Chapman",
    description: "Classic Nigerian fruity cocktail drink.",
    price: 1200,
    image: "/foods/drinks-1.jpg",
    category: "drinks",
  },
  {
    id: 17,
    name: "Palm Wine",
    description: "Freshly tapped palm wine, chilled.",
    price: 1500,
    image: "/foods/drinks-2.jpg",
    category: "drinks",
  },
  {
    id: 18,
    name: "Zobo Drink",
    description: "Refreshing hibiscus drink served cold.",
    price: 800,
    image: "/foods/drinks-3.jpg",
    category: "drinks",
  },
  {
    id: 19,
    name: "Coca Cola",
    description: "Chilled canned or bottled coke.",
    price: 500,
    image: "/foods/drinks-4.jpg",
    category: "drinks",
  },
  {
    id: 20,
    name: "Table Water",
    description: "Pure healthy bottled water from reputable factories.",
    price: 200,
    image: "/foods/drinks-5.jpg",
    category: "drinks",
  },

  // === Snacks ===
  {
    id: 21,
    name: "Meat Pie",
    description: "Buttery pastry filled with minced meat and veggies.",
    price: 600,
    image: "/foods/snacks-1.jpg",
    category: "snacks",
  },
  {
    id: 22,
    name: "Puff-Puff",
    description: "Fluffy fried dough balls dusted with sugar.",
    price: 100,
    image: "/foods/snacks-2.jpg",
    category: "snacks",
  },
  {
    id: 23,
    name: "Chin Chin",
    description: "Crunchy fried snack made from sweet dough.",
    price: 700,
    image: "/foods/snacks-3.jpg",
    category: "snacks",
  },
  {
    id: 24,
    name: "Egg Roll",
    description: "Deliciously prepared and enriched egg roll.",
    price: 500,
    image: "/foods/snacks-4.jpg",
    category: "snacks",
  },
  {
    id: 25,
    name: "Shawarma",
    description: "Spiced meat wrapped in flatbread with veggies and sauce.",
    price: 4500,
    image: "/foods/snacks-5.jpg",
    category: "snacks",
  },
  {
    id: 26,
    name: "Pizza",
    description: "Classic Italian pizza topped with cheese, tomato sauce, and your choice of toppings.",
    price: 8500,
    image: "/foods/snacks-6.jpg",
    category: "snacks",
  },
];

export default foods;
